import { useMemo } from "react";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import { SubmissionFile } from "@/bryntum-lib/models/SubmissionFile";

export interface LinkedSubmissionFile {
  submissionFile: SubmissionFile;
  fileName: string | null;
}

export function useSubmissionFiles(
  submissionId: number | null | undefined,
): LinkedSubmissionFile[] {
  const { project } = useSwivuBryntumContext();
  const { version: sfVersion } = useSwivuStore({ storeId: STORE_KEYS.submissionfilesStore });

  return useMemo(() => {
    if (!project || submissionId == null) return [];
    const sfStore = project.getCrudStore(STORE_KEYS.submissionfilesStore);
    if (!sfStore) return [];

    const linked =
      (sfStore.query((r: SubmissionFile) => r.submission === submissionId) as unknown as SubmissionFile[]) ??
      [];

    return linked.map((submissionFile) => ({
      submissionFile,
      fileName: submissionFile.name?.trim() || null,
    }));
  }, [project, submissionId, sfVersion]);
}
